import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=c6d135d4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Rodape.vue"
export default component.exports